import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { SOURCES } from "@/lib/sources";

const sorted = Object.entries(SOURCES).sort(([, a], [, b]) => a.full.localeCompare(b.full));

export default function Sources() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ block: "center" }), 300);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="sources-page">
      <Navbar />
      <CartDrawer />
      <section className="px-5 pb-24 pt-28 md:px-10 md:pt-36">
        <div className="mx-auto max-w-[1100px]">
          <p className="eyebrow mb-6">Evidenze, non mode</p>
          <h1 className="font-display text-6xl font-900 uppercase leading-[0.85] md:text-8xl">Fonti<span className="text-[#c4dcca]">.</span></h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#a3b1aa] md:text-lg">
            Gli studi e i libri citati nelle frasi del sito. Sono tratti dalle bibliografie delle guide PDF della Collana HHL, dove ogni argomento è approfondito.
          </p>
          <ol className="mt-14 divide-y divide-white/10 border-y border-white/10" data-testid="sources-list">
            {sorted.map(([k, s]) => (
              <li key={k} id={k} data-testid={`source-${k}`} className={`scroll-mt-28 py-5 text-sm leading-relaxed md:text-base ${hash === `#${k}` ? "bg-[#98bfa2]/10" : ""}`}>
                <span className="mb-1 block font-mono text-xs uppercase tracking-widest text-[#98bfa2]">{s.short}</span>
                <span className="text-[#f4f7f5]">{s.full}</span>
              </li>
            ))}
          </ol>
          <p className="mt-10 text-xs text-[#a3b1aa]">I contenuti hanno finalità educative e non sostituiscono il parere di medici, psicologi o dietisti.</p>
        </div>
      </section>
      <Footer />
    </main>
  );
}
